import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BinIcon12 = (props: SvgProps) => <Svg
  width={14}
  height={15}
  viewBox='0 0 14 15'
  fill='none'
  {...props}
>
  <Path
    d='M11.1719 2.51953L10.5375 12.8227C10.5319 13.1052 10.4172 13.3746 10.2174 13.5744C10.0175 13.7742 9.74815 13.8889 9.46563 13.8945H3.90937C3.62685 13.8889 3.35745 13.7742 3.15764 13.5744C2.95782 13.3746 2.8431 13.1052 2.8375 12.8227L2.20312 2.51953M1 2.51953H12.375H1ZM4.5 2.51953V1.62266C4.5 1.39639 4.58988 1.1794 4.74987 1.01941C4.90987 0.859414 5.12686 0.769531 5.35312 0.769531H8.02187C8.13391 0.769531 8.24485 0.791598 8.34835 0.834472C8.45186 0.877345 8.54591 0.940186 8.62513 1.01941C8.70435 1.09863 8.76719 1.19267 8.81006 1.29618C8.85293 1.39969 8.875 1.51062 8.875 1.62266V2.51953H4.5Z'
    stroke={props.color ?? '#ED364C'}
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M8.875 4.26953L8.4375 12.1445M6.6875 4.26953V12.1445V4.26953ZM4.5 4.26953L4.9375 12.1445L4.5 4.26953Z'
    stroke={props.color ?? '#ED364C'}
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default BinIcon12;
